import { message } from 'antd'
import Button from 'components/Button'
import DatePicker from 'components/DatePickerStyles/DatePicker/index'
import { TimeStyles } from 'components/DatePickerStyles/DatePickerStyles'
import Checkbox from 'components/Form/Checkbox'
import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import Clock from 'components/icons/Clock'
import DeleteIcon from 'components/icons/Delete'
import DeleteColor from 'components/icons/DeleteColor'
import NotificationsIcon from 'components/icons/NotificationIcons'
import PlusIcon from 'components/icons/PlusIcon'
import RichEditor from 'components/RichEditor'
import Select from 'components/Select'
import {
  FlexWrap,
  FormItem,
  FormItemDiv,
} from 'components/UIComponents/FormStyles'
import Toggle from 'components/UIComponents/Toggle/ToggleIndex.js'
import FileReader from 'components/Uploader/FileReader'
import FileUploader from 'components/Uploader/FileUpload.js'
import { SecondGreyText } from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Flex from '../../../../components/Flex'
import Checkboxed from '../../../../components/Form/Checkboxed'
import EventCard from './partials/Card'
import { StyledRightStick } from './partials/Card/style'
import CtcSelect from './partials/ctc'
import ImageUploader from './partials/ImageUploader/Imageuploader'
import {
  ButtonDirection,
  Container,
  Dummy,
  FlexWrapper,
  LabelDiv,
  NoDataFound,
  SelectWrapper,
  TierInputNumber,
  TypeGroup,
} from './style'

import { getEligibilityCriteria } from 'modules/Events/actions'
import { useDispatch } from 'react-redux'

export const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox + span {
    padding-left: 12px;
    font-size: 13px;
    font-weight: ${props => (props.fontWeight ? props.fontWeight : '400')};
  }
  .ant-checkbox-inner {
    width: 12px !important;
    height: 12px !important;
    border-radius: 3px !important;
  }

  .ant-checkbox-input {
    margin-bottom: 10px !important;
  }
  &.ant-checkbox-wrapper {
    align-items: flex-start !important;
  }
  .ant-checkbox {
    margin-top: 2px !important;
  }
`

const EventForm = ({
  form,
  isFieldsMandatory,
  selectedData,
  qualificationData,
  setQualificationData,
  updateIsSelected,
  selectedType,
  EventFormData,
  eventData,

  setSelectedData,
  speakerFields,
  setSpeakerFields,
}) => {
  const dispatch = useDispatch()

  const eventTypes = [
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#001B48',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Others</span>{' '}
        </div>
      ),
      value: 'OTHERS',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#97CADB',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Pre Placement Talk</span>{' '}
        </div>
      ),
      value: 'PRE_PLACEMENT_TALK',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#B5A3F7',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Seminar</span>{' '}
        </div>
      ),
      value: 'SEMINAR',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#E1A7BA',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Webinar</span>{' '}
        </div>
      ),
      value: 'WEBINAR',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#8D6AA0',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Lecture</span>{' '}
        </div>
      ),
      value: 'LECTURE',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#F29F05',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Conference</span>{' '}
        </div>
      ),
      value: 'CONFERENCE',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#F25C05',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Panel Discussion</span>{' '}
        </div>
      ),
      value: 'PANEL_DISCUSSION',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#31AAB5',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Hackathon</span>{' '}
        </div>
      ),
      value: 'HACKATHON',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#72B06F',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Workshop</span>{' '}
        </div>
      ),
      value: 'WORKSHOP',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#4C1D91',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Campaign</span>{' '}
        </div>
      ),
      value: 'CAMPAIGN',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#13593F',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Sports Event</span>{' '}
        </div>
      ),
      value: 'SPORTS_EVENT',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#02457A',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Activity/Event</span>{' '}
        </div>
      ),
      value: 'ACTIVITY_EVENT',
    },
    {
      name: (
        <div>
          <span
            style={{
              width: '10px',
              height: '10px',
              background: '#595F33',
              borderRadius: '50%',
              display: 'inline-block',
            }}
          ></span>
          &nbsp;&nbsp; <span>Exhibition</span>{' '}
        </div>
      ),
      value: 'EXHIBITION',
    },
  ]
  const [isCheckboxSelected, setIsCheckboxSelected] = useState(false)
  const [selectedItems, setSelectedItems] = useState('ALL')
  const [types, setTypes] = useState([])
  const [selectedStudents, setSelectedStudents] = useState([])
  const [files, setFiles] = useState(form.getFieldValue('documents') ?? [])
  const [searchData, setSearchData] = useState('')
  const [isRegister, setIsRegister] = useState(false)

  useEffect(() => {
    form.setFieldsValue({ documents: files })
  }, [files])

  const handleLabelClick = value => {
    setSelectedItems(value)
    onSearchQualification(searchData, value)
  }
  const handleCheckboxChange = checkedValues => {
    setSelectedStudents(checkedValues)
    onSearchQualification(searchData, selectedItems, checkedValues)

    if (checkedValues?.length > 0) {
      setIsCheckboxSelected(true)
    } else {
      setSearchData('')
      setIsCheckboxSelected(false)
    }
  }
  const onCheckboxChange = e => {
    let checkedValues = selectedStudents
    if (e.target.checked) {
      checkedValues = [...selectedStudents, e.target.value]
    } else {
      checkedValues = checkedValues.filter(item => item !== e.target.value)
    }
    handleCheckboxChange(checkedValues)
  }

  const validateRegisterEndDate = (_, value) => {
    if (
      !value ||
      !form.getFieldValue('endDate') ||
      !form.getFieldValue('registerStartDate')
    ) {
      return Promise.resolve()
    }
    if (
      value.isBefore(form.getFieldValue('endDate')) &&
      value.isAfter(form.getFieldValue('registerStartDate'))
    ) {
      return Promise.resolve()
    }
    return Promise.reject(
      new Error(
        'Registration end date should be between registration start date and event end date'
      )
    )
  }

  const SearchSelectionItems = [
    {
      id: 1,
      label: 'Degree',
      value: 'ALL',
    },
    {
      id: 2,
      label: 'Dept.',
      value: 'STREAM',
    },

    {
      id: 3,
      label: 'Spec.',
      value: 'SPECIALISATION',
    },
  ]
  const validateRegisterStartDate = (_, value) => {
    if (!value || !form.getFieldValue('startDate')) {
      return Promise.resolve()
    }
    if (value.isBefore(form.getFieldValue('startDate'))) {
      return Promise.resolve()
    }
    return Promise.reject(
      new Error(
        'Registration start date should be earlier than event start date'
      )
    )
  }

  const handleSpeakerChange = (index, field, value) => {
    const updatedSpeakers = [...speakerFields]
    updatedSpeakers[index][field] = value
    setSpeakerFields(updatedSpeakers)
    form.setFieldsValue({ speakers: updatedSpeakers })
  }

  const validateFields = () => {
    const speakers = form.getFieldValue('speakers')
    for (let speaker of speakers) {
      if (!speaker.name || !speaker.link) {
        message.error('Please fill out all fields.')
        return false
      }
      const urlPattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
          '(\\#[-a-z\\d_]*)?$',
        'i'
      )
      if (!urlPattern.test(speaker.link)) {
        message.error('Please enter a valid URL.')
        return false
      }
    }

    const links = speakers.map(speaker => speaker.link)
    if (new Set(links).size !== links.length) {
      message.error('Link already exists .')
      return false
    }

    return true
  }

  const checkedData = (
    value,
    field,
    degreeId,
    departmentId,
    specialisationId
  ) => {
    if (field == 'degree') {
      updateIsSelected(field, value, degreeId)
    } else if (field == 'stream') {
      updateIsSelected(field, value, degreeId, departmentId)
    } else if (field == 'specialisation') {
      updateIsSelected(field, value, degreeId, departmentId, specialisationId)
    } else {
      updateIsSelected(field, value)
    }
    form.validateFields(['studentfrom'])
  }
  useEffect(() => {
    const callEducationType = async () => {
      const response = await dispatch(
        getEligibilityCriteria({
          searchValue: '',
          searchType: 'ALL',
          searchField: [],
        })
      )

      const result = response
      if (Array.isArray(result)) {
        const typesArray = [...new Set(result.map(item => item.type))]
        const customOrder = [
          'UG',
          'PG',
          'DIPLOMA',
          'P.G.DIPLOMA',
          'P_G_DIPLOMA',
          'PHD',
        ]
        const sortedQualifications =
          typesArray?.length === 0
            ? []
            : typesArray?.sort(
                (a, b) => customOrder?.indexOf(a) - customOrder?.indexOf(b)
              )
        setTypes(sortedQualifications)
      }
    }

    callEducationType()
  }, [dispatch])

  const onSearchQualification = async (
    searchValue = '',
    searchType = selectedItems,
    searchField = selectedStudents,
    index,
    selected
  ) => {
    if (searchValue?.trim() !== '') {
      const result = await dispatch(
        getEligibilityCriteria({
          searchValue: searchValue?.trim(),
          searchType: searchType,
          searchField: searchField,
        })
      )
      const updatedata = await addIsSelectedFieldforNew(result)
      const mergeSelectedDataToAutoSelect = await defaultSelectedData(
        updatedata,
        selectedData
      )

      setQualificationData(mergeSelectedDataToAutoSelect)
    } else {
      setQualificationData([])
    }
  }

  const filterSelected = data => {
    data
      ?.filter(degree => degree.isSelected)
      ?.map(degree => ({
        degreeId: degree.degreeId,
        shortForm: degree.shortForm,
        isSelected: degree?.isSelected,
        name: degree?.name,
        type: degree?.type,
        streams: degree.streams
          ?.filter(stream => stream.isSelected)
          ?.map(stream => ({
            streamId: stream.streamId,
            name: stream.name,
            isSelected: stream.isSelected,
            specializations:
              stream.specializations?.length > 0
                ? stream.specialisations?.filter(
                    specialisation => specialisation.isSelected
                  )
                : [],
          })),
      }))
    return data
      ?.filter(degree => degree.isSelected)
      ?.map(degree => ({
        degreeId: degree.degreeId,
        name: degree?.name,

        shortForm: degree.shortForm,
        isSelected: degree?.isSelected,
        type: degree?.type,
        streams: degree.streams
          ?.filter(stream => stream.isSelected)
          ?.map(stream => ({
            streamId: stream.streamId,
            name: stream.name,
            isSelected: stream.isSelected,
            specializations:
              stream.specializations?.length > 0
                ? stream.specializations?.filter(
                    specialisation => specialisation.isSelected
                  )
                : [],
          })),
      }))
  }
  function mergeSelections(obj1, obj2) {
    return obj1?.map(degree => {
      const degreeMatch = obj2.find(d => d.degreeId === degree.degreeId)
      const mergedDegree = {
        ...degree,
        isSelected: degreeMatch
          ? degree.isSelected && degreeMatch.isSelected
          : false,
        streams: degree.streams.map(stream => {
          const streamMatch = degreeMatch?.streams.find(
            s => s.streamId === stream.streamId
          )
          return {
            ...stream,
            isSelected: streamMatch
              ? stream.isSelected && streamMatch.isSelected
              : false,
            specializations: stream?.specializations?.map(spec => {
              const specMatch = streamMatch?.specializations?.find(
                sp => sp.id === spec.id
              )
              return {
                ...spec,
                isSelected: specMatch
                  ? spec.isSelected && specMatch.isSelected
                  : false,
              }
            }),
          }
        }),
      }
      return mergedDegree
    })
  }
  const handleRemoveQualificationSelection = (
    item,
    field,
    degreeId,
    departmentId,
    specialisationId
  ) => {
    let deselectedItem = item
    updateIsDeSelected(
      deselectedItem,
      field,
      false,
      degreeId,
      departmentId,
      specialisationId
    )
  }

  const updateIsDeSelected = async (
    deselectedItem,
    field,
    isSelected,
    id,
    departmentId,
    specId
  ) => {
    if (
      field === 'degree' ||
      field === 'stream' ||
      field === 'specialisation'
    ) {
      let isShowing = false
      if (id && !departmentId && !specId) {
        isShowing = selectedData?.find(domain => domain.degreeId == id)
      } else if (id && departmentId && !specId) {
        let degree = selectedData?.find(domain => domain.degreeId == id)
        isShowing = degree?.streams?.find(
          stream => stream.streamId == departmentId
        )
      } else {
        let degree = selectedData?.find(domain => domain.degreeId == id)
        let department = degree?.streams?.find(
          stream => stream.streamId == departmentId
        )

        isShowing = department?.specializations?.find(spec => spec.id == specId)
      }
      let updatedData = []
      if (isShowing) {
        updatedData = selectedData?.map(domain => {
          // Check if id exists in the domain
          if (domain.degreeId === id && !departmentId && !specId) {
            if (isSelected) {
              return {
                ...domain,
                isSelected: isSelected,
              }
            } else {
              domain?.streams?.forEach(stream => {
                stream.isSelected = false
                stream?.specializations?.forEach(spec => {
                  spec.isSelected = false
                })
              })
              return {
                ...domain,
                isSelected: isSelected,
              }
            }
          }
          if (domain.degreeId === id && departmentId) {
            const updatedStreams = domain.streams.map(stream => {
              // Check if id exists in the stream
              if (stream.streamId === departmentId && !specId) {
                if (isSelected) {
                  if (domain.degreeId === id) {
                    domain.isSelected = true
                  }
                } else {
                  // Uncheck all specializations in the stream
                  stream?.specializations?.forEach(spec => {
                    spec.isSelected = false
                  })
                }

                return {
                  ...stream,
                  isSelected: isSelected,
                }
              }

              if (
                domain.degreeId === id &&
                stream.streamId === departmentId &&
                stream.specializations &&
                id &&
                departmentId &&
                specId
              ) {
                // Check if id exists in the specialisations
                const updatedSpecialisations = stream?.specializations?.map(
                  specialisation => {
                    if (specialisation.id === specId) {
                      if (isSelected) {
                        if (
                          domain.degreeId === id &&
                          departmentId == stream.streamId
                        ) {
                          domain.isSelected = true
                          stream.isSelected = true
                        }
                      }
                      return {
                        ...specialisation,
                        isSelected: isSelected,
                      }
                    }
                    return specialisation
                  }
                )

                // Update stream with modified specialisations
                return {
                  ...stream,
                  specializations: updatedSpecialisations,
                }
              }

              return stream
            })
            // Update domain with modified streams
            return {
              ...domain,
              streams: updatedStreams,
            }
          }
          return domain
        })
      }
      let data = filterSelected(updatedData)
      setSelectedData(data)
      const mergeSelectedDataToAutoSelect = mergeSelections(
        qualificationData,
        data
      )
      setQualificationData(mergeSelectedDataToAutoSelect)
    } else {
      if (field == 'allDegree') {
        const updatedData = selectedData?.map(domain => {
          return {
            ...domain,
            isSelected: isSelected,
          }
        })
        setSelectedData(updatedData)
      } else if (field == 'allStream') {
        const updatedData = selectedData?.map(domain => {
          if (domain?.streams?.length > 0) {
            domain?.streams?.forEach(stream => {
              stream.isSelected = isSelected
              stream?.specializations?.forEach(speciaisation => {
                speciaisation.isSelected = isSelected
                  ? speciaisation?.isSelected
                  : isSelected
              })
            })
          }
          return {
            ...domain,
            isSelected: isSelected ? isSelected : domain.isSelected,
          }
        })

        setSelectedData(updatedData)
      } else {
        const updatedData = selectedData.map(degree => {
          let degreeSelected = degree?.isSelected
          const updatedStreams = degree.streams.map(stream => {
            let streamSelected = stream?.isSelected
            const updatedSpecialisations = stream?.specializations?.map(
              specialisation => {
                if (specialisation) {
                  streamSelected = true
                  degreeSelected = true
                }
                return { ...specialisation, isSelected: isSelected }
              }
            )
            return {
              ...stream,
              specializations: updatedSpecialisations,
              isSelected: streamSelected,
            }
          })
          return {
            ...degree,
            streams: updatedStreams,
            isSelected: degreeSelected,
          }
        })

        setSelectedData(updatedData)
      }
    }
  }

  const defaultSelectedData = async (completeData, selectedSection) => {
    const newData = await completeData?.map(degree => {
      const selectedDegree = selectedSection?.find(
        sd => sd.degreeId === degree.degreeId
      )
      if (selectedDegree) {
        degree.isSelected = true
        degree.streams = degree?.streams?.map(stream => {
          const selectedStream = selectedDegree.streams?.find(
            ss => ss.streamId === stream.streamId
          )
          if (selectedStream) {
            stream.isSelected = true

            stream.specializations = stream?.specializations?.map(
              specialisation => {
                if (
                  selectedStream.specializations?.some(
                    selectedSpecialisation =>
                      selectedSpecialisation.id === specialisation.id
                  )
                ) {
                  specialisation.isSelected = true
                }

                return specialisation
              }
            )
          }
          return stream
        })
      }
      return degree
    })

    return newData
  }

  function addIsSelectedFieldforNew(data) {
    return data?.map(domain => {
      return {
        degreeId: domain?.degreeId,
        name: domain?.degreeName,
        type: domain?.type,
        shortForm: domain?.degreeShortForm,
        isSelected: false,
        streams: domain?.streams?.map(streamMap => {
          const stream = streamMap?.stream
          return {
            id: streamMap?.streamId,
            streamId: streamMap?.streamId,
            name: streamMap?.streamName,
            status: streamMap?.streamStatus,
            isSelected: false,
            specializations: streamMap?.specialisations?.map(specialisation => {
              return {
                id: specialisation?.specialisationId,
                name: specialisation?.specialisationName,
                status: specialisation?.specialisationStatus,

                isSelected: false,
              }
            }),
          }
        }),
      }
    })
  }

  function addIsSelectedField(data) {
    return data?.map(domain => {
      return {
        ...domain,
        isSelected: false, // Replace "value" with the desired value or logic
        streams: domain.streams.map(stream => {
          return {
            ...stream,
            isSelected: false, // Replace "value" with the desired value or logic
            specialisations: stream.specialisations.map(specialisation => {
              return {
                ...specialisation,
                isSelected: false, // Replace "value" with the desired value or logic
              }
            }),
          }
        }),
      }
    })
  }
  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  const onSearchValue = debounce(
    (search, index, searchField, selected, toSearch) => {
      onSearchQualification(search, toSearch, searchField, index, selected)
    },

    600
  )

  useEffect(() => {
    if (eventData) {
      form.setFieldsValue({
        ...eventData,
        speakers: eventData.speakers.map((speaker, index) => ({
          ...speaker,
          key: index,
        })),
      })
    }
  }, [eventData, form])

  const TableComponent = ({ selectedData, selectedKey, type }) => (
    <table className="custom-table">
      <thead>
        <tr style={{ border: '1px solid gray' }}>
          <th style={{ width: '10%' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <StyledCheckbox
                checked={!selectedData?.find(item => item.isSelected === false)}
                fontWeight={600}
                onChange={({ target }) => {
                  checkedData(target?.checked, 'allDegree')
                }}
              />
              <span style={{ marginLeft: '-8px', fontWeight: 600 }}>
                DEGREE
              </span>
            </div>
          </th>
          <th style={{ width: '45%' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <StyledCheckbox
                fontWeight={600}
                checked={
                  selectedData?.every(
                    item =>
                      item.streams.length === 0 ||
                      item.streams.every(stream => stream.isSelected !== false)
                  ) &&
                  selectedData?.map(item => item?.streams)?.flat()?.length > 0
                }
                onChange={({ target }) => {
                  checkedData(target?.checked, 'allStream')
                }}
              />
              <span style={{ marginLeft: '-8px', fontWeight: 600 }}>
                DEPARTMENT
              </span>
            </div>
          </th>
          <th style={{ width: '45%' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <StyledCheckbox
                checked={
                  selectedData?.every(item =>
                    item?.streams?.every(
                      stream =>
                        stream?.specializations?.length === 0 ||
                        stream?.specializations?.every(
                          specialization => specialization?.isSelected !== false
                        )
                    )
                  ) &&
                  selectedData
                    ?.map(item => item?.streams)
                    ?.flat()
                    ?.map(item => item?.specializations)
                    ?.flat()?.length > 0
                }
                fontWeight={600}
                onChange={({ target }) => {
                  checkedData(target?.checked, 'allSpec')
                }}
              />
              <span style={{ marginLeft: '-8px', fontWeight: 600 }}>
                SPECIALIZATION
              </span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {selectedData?.map(degree => (
          <React.Fragment key={degree?.degreeId}>
            <tr>
              <td>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <StyledCheckbox
                    checked={degree?.isSelected}
                    fontWeight={600}
                    onChange={({ target }) => {
                      checkedData(target?.checked, 'degree', degree?.degreeId)
                    }}
                  />
                  <span style={{ marginLeft: '-8px', fontWeight: 600 }}>
                    {degree?.shortForm}
                  </span>
                </div>
              </td>
              <td></td>
              <td></td>
            </tr>
            {degree?.streams?.map(stream => (
              <React.Fragment key={stream?.streamId}>
                <tr>
                  <td
                    style={{
                      paddingLeft: '2.5em',
                      color: '#c0c0c0',
                      fontSize: 'smaller',
                    }}
                  >
                    {degree?.shortForm}
                  </td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <StyledCheckbox
                        checked={stream?.isSelected}
                        onChange={({ target }) => {
                          checkedData(
                            target?.checked,
                            'stream',
                            degree?.degreeId,
                            stream?.streamId
                          )
                        }}
                      />
                      <span style={{ marginLeft: '-8px', fontWeight: 600 }}>
                        {stream?.name}
                      </span>
                    </div>
                  </td>
                  <td></td>
                </tr>
                {stream?.specializations?.map(
                  (specialisation, specialisationIndex) => (
                    <tr key={specialisationIndex + 'specialisation'}>
                      <td
                        style={{
                          paddingLeft: '2.5em',
                          color: '#c0c0c0',
                          fontSize: 'smaller',
                        }}
                      >
                        {degree?.shortForm}
                      </td>
                      <td
                        style={{
                          paddingLeft: '2.5em',
                          color: '#c0c0c0',
                          fontSize: 'smaller',
                        }}
                      >
                        {stream?.name}
                      </td>
                      <td>
                        {' '}
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <StyledCheckbox
                            checked={specialisation?.isSelected}
                            onChange={({ target }) => {
                              checkedData(
                                target?.checked,
                                'specialisation',
                                degree?.degreeId,
                                stream?.streamId,
                                specialisation?.id
                              )
                            }}
                          />
                          <span style={{ marginLeft: '-8px', fontWeight: 600 }}>
                            {' '}
                            {specialisation?.name}
                          </span>
                        </div>
                      </td>
                    </tr>
                  )
                )}
              </React.Fragment>
            ))}
          </React.Fragment>
        ))}
      </tbody>
    </table>
  )

  const handleFileRemove = index => {
    if (files && files.length > 0) {
      const updatedFiles = files.filter((_, i) => i !== index)
      setFiles(updatedFiles)

      const updatedFileURLs = fileURL.filter((_, i) => i !== index)
      setFileURL(updatedFileURLs)
    } else {
      message.error('No files to remove.')
    }
  }

  const addSpeakerField = () => {
    if (validateFields()) {
      setSpeakerFields([...speakerFields, { name: '', link: '' }])
    }
  }

  const deleteSpeakerField = index => {
    const updatedSpeakers = speakerFields.filter((_, i) => i !== index)
    setSpeakerFields(updatedSpeakers)
    form.setFieldsValue({ speakers: updatedSpeakers })
  }

  const [yearOptions, setYearOptions] = useState([])
  const [isOffline, setIsOffline] = useState(
    form.getFieldValue('eventMode') !== 'ONLINE'
  )
  const [isAllDayEvent, setIsAllDayEvent] = useState(false)
  const [file, setFile] = useState(form.getFieldValue('banner') || null)
  const [endTime, setEndTime] = useState(null)
  const [startTime, setStartTime] = useState(null)
  const [registerendTime, setRegisterEndTime] = useState(null)

  const [fileURL, setFileURL] = useState('')
  const [startDate, setStartDate] = React.useState(
    form.getFieldValue('startDate') || null
  )
  const [registerStartDate, setRegStartDate] = React.useState(
    form.getFieldValue('registerStartDate') || null
  )

  const disabledStartDate = current => {
    return current && current < moment().startOf('day')
  }
  const disabledRegStartDate = current => {
    return current && current < moment().startOf('day')
  }

  const disabledEndDate = current => {
    return current && current < startDate
  }
  const disabledRegEndDate = current => {
    return current && current < registerStartDate
  }

  const handleStartDateChange = date => {
    setStartDate(date)
    form.setFieldsValue({ endDate: null })
    form.setFieldsValue({ registerEndDate: null })
    form.setFieldsValue({ registerStartDate: null })
  }
  const handleRegStartDateChange = date => {
    setRegStartDate(date)
    form.setFieldsValue({ registerEndDate: null })
  }

  const onAllDayEventChange = e => {
    setIsAllDayEvent(e.target.checked)

    setStartTime(null)
    setEndTime(null)
    form.setFieldsValue({ startTime: '' })
    form.setFieldsValue({ endTime: '' })
  }
  const onRegisterChange = e => {
    setIsRegister(e.target.checked)
    form.setFieldsValue({ isRegister: e.target.checked })

    setRegisterEndTime(null)
    setRegStartDate(null)
    form.setFieldsValue({ registrationLink: '' })
    form.setFieldsValue({ registerEndTime: null })
    form.setFieldsValue({ registerEndDate: null })
    form.setFieldsValue({ registerStartDate: null })
    form.setFieldsValue({ registerAmount: '' })
  }

  useEffect(() => {
    //console.log(form, form.getFieldValue('category'), 'data')
    // setFile(form.getFieldValue('banner'))
  }, [form.getFieldValue('title')])

  useEffect(() => {
    setIsAllDayEvent(form.getFieldValue('allDayEvent'))
    setIsRegister(form.getFieldValue('isRegister'))
  }, [form])

  useEffect(() => {
    const d = new Date()
    let currYear = d.getFullYear()
    let years = []
    for (let i = 2010; i <= currYear + 4; i++) {
      years.push({ name: i, value: i })
    }
    setYearOptions(years?.reverse())
  }, [])
  useEffect(() => {
    form.setFieldsValue({ banner: file })
  }, [file])
  useEffect(() => {
    if (isOffline)
      form.setFieldsValue({
        eventMode: 'OFFLINE',
      })
  }, [])

  const phoneNumberPattern = /^\d{10}$/

  const onChangeHandler = (value, key) => {
    form.setFieldsValue({ [key]: value })
  }

  const onChangeHandlerr = value => {
    setIsOffline(value === 'OFFLINE')
    form.setFieldsValue({
      eventMode: value,
    })
  }

  const onTimeChange = (time, timeString) => {
    setStartTime(time)
    form.setFieldsValue({ startTime: timeString })
    if (time.isSameOrAfter(endTime)) {
      setEndTime(null) // Reset end time if it is before or the same as start time
      form.setFieldsValue({ endTime: null }) // Reset the form field for end time
    }
  }

  const onEndTimeChange = (time, timeString) => {
    setEndTime(time)
    form.setFieldsValue({ endTime: timeString })
  }

  const onRegisterEndTimeChange = (time, timeString) => {
    setRegisterEndTime(time)
    form.setFieldsValue({ registerEndTime: timeString })
  }

  const disabledEndHours = () => {
    if (!startTime) return []
    const startHour = startTime.hour()
    return Array.from({ length: startHour }, (_, i) => i)
  }

  const disabledEndMinutes = selectedHour => {
    if (!startTime || selectedHour !== startTime.hour()) return []
    const startMinute = startTime.minute()
    return Array.from({ length: startMinute + 1 }, (_, i) => i)
  }

  const RadioOptions3 = types.map((type, index) => ({
    label: type,
    value: type,
  }))

  const customValidator = (_, value) => {
    if (isFieldsMandatory && selectedData?.length === 0) {
      return Promise.reject(new Error('Please Select Degree'))
    }
    return Promise.resolve()
  }

  const onChangeCatagory = (value, options) => {
    form.setFieldsValue({ category: value })
  }

  return (
    <>
      <StyledRightStick>
        <EventCard
          selectedData={selectedData}
          handleRemoveFilter={handleRemoveQualificationSelection}
        />
      </StyledRightStick>
      <FormItem name={'title'}>
        <LabelDiv>Event Name *</LabelDiv>
        <Input
          width="100%"
          placeholder="Enter event name"
          optional={'*'}
          name={'title'}
          rules={[
            () => ({
              validator(_, value) {
                if (!value?.trim()) {
                  return Promise.reject(new Error(`Please enter event name`))
                }
                return Promise.resolve()
              },
            }),
          ]}
          onChange={({ target }) => {
            onChangeHandler(target.value, 'title')
          }}
        />
      </FormItem>

      <FormItem name={'banner'}>
        <LabelDiv>Event Banner</LabelDiv>
        {!file?.url && (
          <ImageUploader
            isImage={true}
            fileName={'document'}
            // format=": 600px W x 200px H"
            setFile={setFile}
          />
        )}
        {file?.url && (
          <Flex row>
            <img
              src={file?.url}
              style={{ height: '180px', width: '460px' }}
              alt="fileImage"
            />
            <ButtonDirection>
              <Button.Secondary
                text="Delete"
                height="34px"
                width="100px"
                icon={<DeleteColor />}
                onClick={() => setFile(null)}
              />
            </ButtonDirection>
          </Flex>
        )}
      </FormItem>
      <FormItem>
        <LabelDiv>Event category *</LabelDiv>
        <FormItem
          name={'category'}
          rules={[
            {
              required: isFieldsMandatory,
              message: 'Please enter event category',
            },
          ]}
        >
          <Select
            width="100%"
            valueParam="value"
            placeholder="Select event category"
            name="category"
            OptionData={eventTypes}
            showSearch={false}
            nameParam="name"
            onChange={onChangeCatagory}
          />
        </FormItem>
      </FormItem>
      <FlexWrapper>
        <SelectWrapper>
          <FormItem>
            <DatePicker
              name={'startDate'}
              rules={[
                {
                  required: isFieldsMandatory,
                  message: 'Please enter event start date',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || value.isSameOrAfter(new Date(), 'day')) {
                      return Promise.resolve()
                    }
                    return Promise.reject(
                      new Error('Start date cannot be earlier than today.')
                    )
                  },
                }),
              ]}
              width="100%"
              label="Event start Date *"
              disabledDate={disabledStartDate}
              onChange={handleStartDateChange}
              showToday={false}

              // value={form.getFieldValue('startDate')}
            />
          </FormItem>
        </SelectWrapper>
        <SelectWrapper>
          <FormItem name={'endDate'}>
            <DatePicker
              name={'endDate'}
              rules={[
                {
                  required: isFieldsMandatory,
                  message: 'Please enter event end date',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || value.isSameOrAfter(new Date(), 'day')) {
                      return Promise.resolve()
                    }
                    return Promise.reject(
                      new Error('End date cannot be earlier than today.')
                    )
                  },
                }),
              ]}
              width="100%"
              label="Event end Date * "
              disabledDate={disabledEndDate}
              isEditable={!form.getFieldValue('startDate')}
              showToday={false}

              // value={form.getFieldValue('endDate')}
            />
          </FormItem>
        </SelectWrapper>
      </FlexWrapper>
      <FormItem name={'allDayEvent'} valuePropName="checked">
        {/* <Checkbox onChange={onAllDayEventChange}  */}
        <Checkbox
          onChange={e => {
            onAllDayEventChange(e)
            setIsAllDayEvent(e.target.checked)
          }}
          label={'All-day event'}
          name="allDayEvent"
          value={form.getFieldValue('allDayEvent')}
        />
      </FormItem>

      {!isAllDayEvent && (
        <FlexWrapper>
          <SelectWrapper>
            <FormItem
              name="startTime"
              rules={[
                {
                  required: isFieldsMandatory,
                  message: 'Please Select Start Time!',
                },
              ]}
            >
              <LabelDiv>Event Start Time *</LabelDiv>
              <div id={'start_time'}>
                <TimeStyles
                  format="HH:mm"
                  showSecond={false}
                  allowClear={false}
                  id="startTime"
                  suffixIcon={<Clock />}
                  value={
                    startTime ||
                    (form.getFieldValue('startTime')
                      ? moment(form.getFieldValue('startTime'), 'HH:mm')
                      : undefined)
                  }
                  placeholder="00:00"
                  onChange={onTimeChange}
                  getPopupContainer={() =>
                    document.getElementById('start_time')
                  }
                />
              </div>
            </FormItem>
          </SelectWrapper>

          <SelectWrapper>
            <FormItem
              name="endTime"
              rules={[
                {
                  required: isFieldsMandatory,
                  message: 'Please select event end time',
                },
              ]}
            >
              <LabelDiv>Event End Time *</LabelDiv>
              <div id={'end_time'}>
                <TimeStyles
                  format="HH:mm"
                  showSecond={false}
                  allowClear={false}
                  suffixIcon={<Clock />}
                  value={
                    endTime ||
                    (form.getFieldValue('endTime')
                      ? moment(form.getFieldValue('endTime'), 'HH:mm')
                      : undefined)
                  }
                  placeholder="00:00"
                  disabledHours={disabledEndHours}
                  disabledMinutes={disabledEndMinutes}
                  onChange={onEndTimeChange}
                  getPopupContainer={() => document.getElementById('end_time')}
                />
              </div>
            </FormItem>
          </SelectWrapper>
        </FlexWrapper>
      )}
      <FormItem
        name={'eventMode'}
        rules={[
          {
            required: false,
            message: 'Please select any one  type',
          },
        ]}
      >
        <Toggle
          left="Offline"
          right="Online"
          onClick={value => {
            onChangeHandlerr(value ? 'ONLINE' : 'OFFLINE')
          }}
          initialValue={isOffline ? 'left' : 'right'}
        />
      </FormItem>
      {isOffline ? (
        <FormItem name={['location']}>
          <div>
            <LabelDiv>Event location </LabelDiv>
            <Input
              width="100%"
              type="text"
              name="location"
              placeholder="Enter event location"
              onChange={e => onChangeHandler(e.target.value, 'location')}
            />
          </div>
        </FormItem>
      ) : (
        <FormItem
          name="onlineLink"
          rules={[
            {
              required: isFieldsMandatory,
              message: 'Please enter online link',
            },
            // () => ({
            //   validator(_, value) {
            //     if (!value) {
            //       return Promise.resolve()
            //     }
            //     return Promise.reject(new Error('Please enter a valid URL'))
            //   },
            // }),
          ]}
        >
          <div>
            <LabelDiv>Online Link *</LabelDiv>
            <Input
              width="100%"
              type="text"
              placeholder="Enter online link"
              name="onlineLink"
              onChange={e => onChangeHandler(e.target.value, 'onlineLink')}
            />
          </div>
        </FormItem>
      )}
      <LabelDiv>Select Degree *</LabelDiv>

      <FormItem
        name={'studentfrom'}
        rules={[
          isFieldsMandatory && selectedData?.length === 0
            ? [{ required: true, message: 'Please Select Degree' }]
            : [{ required: false, message: '' }],
          { validator: customValidator },
        ]}
      >
        {/* <TypeGroup>
          {RadioOptions3?.map((item, index) => (
            <Checkboxed 
              width={'30%'}
              key={index}
              border={true}
              label={item?.label}
              value={item?.value}
              // onChange={({ target }) =>
              //   handleCheckboxChange(target.value, 'types')
              // }      
              onChange={onCheckboxChange}     
            />
          ))}
        </TypeGroup> */}
        <TypeGroup>
          {RadioOptions3 && RadioOptions3.length > 0 ? (
            RadioOptions3.map((item, index) => (
              <Checkboxed
                width={'25%'}
                key={index + 'RadioOption'}
                border={true}
                label={
                  item?.label == 'P_G_DIPLOMA' ? 'PG DIPLOMA' : item?.label
                }
                value={item?.value}
                onChange={onCheckboxChange}
              />
            ))
          ) : (
            <Dummy
              style={{
                marginTop: '-10px',
                position: 'absolute',
              }}
            >
              Please map course
            </Dummy>
          )}
        </TypeGroup>
        {isCheckboxSelected && (
          <>
            <div style={{ marginTop: '10px' }}>
              <Label>Search using keywords</Label>
            </div>
            <div>
              <FormItem>
                <Input
                  // name={['search']}
                  type="text"
                  width="100%"
                  placeholder="Search using keywords"
                  onChange={({ target }) => {
                    setSearchData(target.value)
                    onSearchValue(target.value, selectedType?.[index]?.value)
                  }}
                />
              </FormItem>
            </div>
            <div
              style={{
                height: '30em',
                overflow: 'auto',
                border: '1px solid #e2e2e2',
                boxShadow: '0px 0px 5px 1px #bfd3ff',
                borderRadius: '5px',
                margin: '1em 0em',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  position: 'sticky',
                  top: '0',
                  background: 'white',
                  zIndex: '1',
                }}
              >
                {SearchSelectionItems?.map((item, index) => (
                  <div key={index + 'item'} style={{ display: 'flex' }}>
                    <Label
                      style={{
                        margin: '1em',
                        border: selectedItems.includes(item.value)
                          ? '1px solid blue'
                          : '1px solid gainsboro',
                        borderRadius: '10px',
                        padding: '1em 1.5em',
                        height: '3em',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        letterSpacing: '0.1em',
                      }}
                      onClick={() => handleLabelClick(item.value)}
                    >
                      {item.label}
                    </Label>
                  </div>
                ))}
              </div>
              {qualificationData && qualificationData.length > 0 ? (
                <TableComponent
                  selectedData={qualificationData}
                  qualificationData={qualificationData}
                />
              ) : (
                <NoDataFound>
                  <div style={{ color: 'dimgray' }}>No Data Found</div>
                  <div style={{ color: 'darkgray' }}>
                    Kindly search using other keywords
                  </div>
                </NoDataFound>
              )}
            </div>
          </>
        )}
      </FormItem>
      <FormItemDiv name={'studentfrom'}>
        <div></div>
      </FormItemDiv>
      <FormItem
        name={'yearOfPassing'}
        rules={[
          {
            required: isFieldsMandatory,
            message: 'Please select year',
          },
        ]}
      >
        <Select
          showArrow={true}
          OptionData={yearOptions}
          label="Year of passing *"
          valueParam="value"
          placeholder="Select year"
          mode="multiple"
          onChange={value => onChangeHandler(value, 'yearOfPassing')}
          showSearch={true}
        />
      </FormItem>
      <FormItemDiv name={'yearOfPassing'}>
        <div></div>
      </FormItemDiv>
      <FormItem
        name="isRegister"
        valuePropName="checked"
        rules={[
          {
            required: false,
            message: 'Please select',
          },
        ]}
      >
        <Checkbox
          onChange={onRegisterChange}
          label={'Register for the event'}
        />
      </FormItem>

      {isRegister ? (
        <>
          <FlexWrap margintop="8px" flexWrap marginLeft="-10px">
            <div>
              <NotificationsIcon />
            </div>
            <SecondGreyText color="#3249D7" paddingTop="3px">
              Note : Enter an external registration link here, or leave it blank
              to receive registered student's details from the system
            </SecondGreyText>
          </FlexWrap>
          <FormItem name="registrationLink">
            <div>
              <LabelDiv>Registration Link </LabelDiv>
              <Input
                width="100%"
                type="text"
                placeholder="Enter online link"
                name="registrationLink"
              />
            </div>
          </FormItem>
          <FormItem name="registerStartDate">
            <LabelDiv>Registration start date * </LabelDiv>
            <DatePicker
              name="registerStartDate"
              rules={[
                {
                  required: isFieldsMandatory,
                  message: 'Please enter registration start date',
                },
                {
                  validator: validateRegisterStartDate,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || value.isSameOrAfter(new Date(), 'day')) {
                      return Promise.resolve()
                    }
                    return Promise.reject(
                      new Error(
                        'Registration Start date cannot be earlier than today.'
                      )
                    )
                  },
                }),
              ]}
              style={{ width: '100%' }}
              disabledDate={disabledRegStartDate}
              onChange={handleRegStartDateChange}
              showToday={false}
            />
          </FormItem>
          <FlexWrapper>
            <SelectWrapper>
              <FormItem name={'registerEndDate'}>
                <LabelDiv>Registration end date * </LabelDiv>
                <DatePicker
                  name={'registerEndDate'}
                  rules={[
                    {
                      required: isFieldsMandatory,
                      message: 'Please enter registration end date',
                    },
                    {
                      validator: validateRegisterEndDate,
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || value.isSameOrAfter(new Date(), 'day')) {
                          return Promise.resolve()
                        }
                        return Promise.reject(
                          new Error(
                            'Registration End date cannot be earlier than today.'
                          )
                        )
                      },
                    }),
                  ]}
                  width="100%"
                  disabledDate={disabledRegEndDate}
                  isEditable={!form.getFieldValue('registerStartDate')}
                  showToday={false}
                />
              </FormItem>
            </SelectWrapper>
            <SelectWrapper>
              {/* <FormItem
              name="startTime"
              rules={[
                {
                  required: isFieldsMandatory,
                  message: 'Please Select Start Time!',
                },
              ]}
            >
              <LabelDiv>Event Start Time *</LabelDiv>
              <div id={'start_time'}>
                <TimeStyles
                  format="HH:mm"
                  showSecond={false}
                  id="startTime"
                  suffixIcon={<Clock />}
                  value={
                    startTime ||
                    (form.getFieldValue('startTime')
                      ? moment(form.getFieldValue('startTime'), 'HH:mm')
                      : undefined)
                  }
                  placeholder="00:00"
                  onChange={onTimeChange}
                  getPopupContainer={() =>
                    document.getElementById('start_time')
                  }
                />
              </div>
            </FormItem> */}
              <FormItem
                name="registerEndTime"
                rules={[
                  {
                    required: false,
                    message: 'Please Select Start Time!',
                  },
                ]}
              >
                <LabelDiv
                  style={{ paddingTop: '-20px', paddingBottom: '-20px' }}
                >
                  Registration end time{' '}
                </LabelDiv>
                <div id={'register_End_Time'}>
                  <TimeStyles
                    format="HH:mm"
                    showSecond={false}
                    suffixIcon={<Clock />}
                    id="registerEndTime"
                    width="100%"
                    color="#010E30"
                    opacity="1"
                    placeholder="00:00"
                    onChange={onRegisterEndTimeChange}
                    value={
                      registerendTime ||
                      (form.getFieldValue('registerEndTime')
                        ? moment(form.getFieldValue('registerEndTime'), 'HH:mm')
                        : undefined)
                    }
                    getPopupContainer={() =>
                      document.getElementById('register_End_Time')
                    }
                  />
                </div>
              </FormItem>
            </SelectWrapper>
          </FlexWrapper>
          <LabelDiv style={{ marginBottom: '-18px' }}>
            Registration Amount{' '}
          </LabelDiv>
          <Container>
            <CtcSelect
              borderRadius="8px"
              bordered={true}
              defaultValue={'INR'}
              disabled={true}
              width="78px"
              style={{ backgroundColor: '#D6DBF7' }}
            />
            <FormItem
              name={'registerAmount'}
              rules={[
                {
                  required: false,
                  message: 'Please enter amount',
                },
                () => ({
                  validator(_, value) {
                    if (value) {
                      if (value < 0) {
                        return Promise.reject(
                          new Error(`The value must be greater than 0`)
                        )
                      }
                    }
                    return Promise.resolve()
                  },
                }),
              ]}
            >
              <TierInputNumber
                style={{ width: '100%' }}
                height="40px"
                borderRadius={'0 8px 8px 0'}
                formatter={value =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
              />
            </FormItem>
          </Container>
        </>
      ) : null}

      <FormItem name={'description'}>
        <RichEditor
          labelName="Event description"
          placeholder="Enter Event Description .."
        />
      </FormItem>

      {/* <FormItem
        name={'eventLink'}
        rules={[{ required: false, message: 'Please enter event name' }]}
      >
        <LabelDiv>Link</LabelDiv>
        <Input
          width="100%"
          type="text"
          placeholder="Enter link"
          name={'eventLink'}
          // value= {form.getFieldValue('eventLink')}
        />
      </FormItem> */}

      <FormItem
        name={'documents'}
        rules={[{ required: false, message: 'Please upload documents' }]}
        // style={{ marginTop: '-50px', position: 'absolute' }}
      />
      <FileUploader
        isDefault={true}
        file={files}
        setFile={setFiles}
        setFileURL={setFileURL}
        fileURL={fileURL}
        format="(.xlsx, .csv, .jpeg, .png, .ppt, .doc, .pdf)"
      />
      {files?.map((item, index) => (
        <FileReader
          file={item}
          setFile={setFiles}
          fileURL={fileURL?.[index]}
          setFileURL={setFileURL}
          progress="100"
          // setErrorMessage={setErrorMessage}
          key={index + 'file'}
          handleRemoveClick={() => handleFileRemove(index)}
        />
      ))}

      <FormItem name={'pocName'}>
        <LabelDiv>POC Name</LabelDiv>
        <Input
          width="100%"
          type="text"
          placeholder="Enter POC Name"
          name={'pocName'}
        />
      </FormItem>
      <FormItem name={'pocNumber'}>
        <LabelDiv>POC Number</LabelDiv>
        <Input
          width="100%"
          placeholder="Enter POC Number"
          name={'pocNumber'}
          rules={[
            {
              validator(_, value) {
                if (!value || phoneNumberPattern.test(value)) {
                  return Promise.resolve()
                }
                return Promise.reject(
                  new Error('Please enter a valid phone number')
                )
              },
            },
          ]}
        />
      </FormItem>

      <div>
        <LabelDiv>Speakers/Panellist</LabelDiv>
        {speakerFields.map((speaker, index) => (
          <div key={index + 'Speaker'}>
            <FormItem
              name={['speakers', index, 'name']}
              rules={[{ required: false, message: 'Please enter a name' }]}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Input
                  width="100%"
                  type="text"
                  placeholder="Enter name"
                  value={form.getFieldValue(['speakers', index, 'name'])}
                  onChange={e =>
                    handleSpeakerChange(index, 'name', e.target.value)
                  }
                  style={{ marginTop: '10px', positon: 'absolute' }}
                />
                {speakerFields.length > 1 && (
                  <Button
                    type="text"
                    icon={<DeleteIcon />}
                    onClick={() => deleteSpeakerField(index)}
                    style={{
                      marginLeft: '-40px',
                      marginTop: '8px',
                      positon: 'relative',
                    }}
                  />
                )}
              </div>
            </FormItem>
            <FormItem
              name={['speakers', index, 'link']}
              rules={[
                {
                  required: false,
                  message: 'Please enter a LinkedIn profile link',
                },
              ]}
            >
              <Input
                width="100%"
                style={{ marginTop: '10px' }}
                placeholder="Enter LinkedIn profile link"
                // value={speaker.link}
                value={form.getFieldValue('speaker?.link')}
                onChange={e =>
                  handleSpeakerChange(index, 'link', e.target.value)
                }
              />
            </FormItem>
          </div>
        ))}
        <Button.Secondary
          text="Add more speakers"
          width="100%"
          icon={<PlusIcon color="#3249D7" />}
          dashed={true}
          style={{ marginTop: '10px', marginBottom: '50px' }}
          onClick={addSpeakerField}
          disabled={speakerFields.some(field => !field.name || !field.link)}
        />
      </div>
    </>
  )
}
export default EventForm
